import React, { useContext } from "react";
import { Layout, Form, Input, Button } from "antd";
import { ToastContainer, toast } from "react-toastify";
import { loginUser } from "../../services/user";
import { Store } from "../../store";
import { _setToken } from "../../services/client";

export const Login = (props) => {
  const { dispatch } = useContext(Store);

  const onFinish = (values) => {
    loginUser(values).then((res) => {
      if (res.status == 1) {
        localStorage.setItem("monitoring_system", JSON.stringify(res.data));
        _setToken(res.data.token);
        dispatch({
          type: "SET_SESSION",
          payload: res.data,
        });
        props.history.push(`${process.env.PUBLIC_URL}/server/list`);
      } else {
        toast.error(
          <>
            {res.data.map((mes, index) => {
              return <p key={index}>{mes.msg}</p>;
            })}
          </>
        );
      }
    });
  };
  return (
    <Layout className="main-layout">
      <Layout.Content className="layout-content">
        <Form
          name="normal_login"
          className="authentication-box "
          onFinish={onFinish}
          layout={"vertical"}
        >
          <h3>ログイン</h3>
          <Form.Item
            name="login"
            label={
              <div>
                ログイン ID<span className="required-field">(必須)</span>
              </div>
            }
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="password"
            label={
              <div>
                パスワード<span className="required-field">(必須)</span>
              </div>
            }
          >
            <Input type="password" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              ログイン
            </Button>
          </Form.Item>
        </Form>
      </Layout.Content>
      <ToastContainer />
    </Layout>
  );
};
